// You can write more code here

import { Customization } from '@/common/types/student';
import { getIconPath } from '@/game/GameComponents/PhaserGame/Utils/CosmeticUtils';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { waitForSeconds } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

export default class PurchaseNotification extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // graphicContainer
    const graphicContainer = scene.add.container(0, 0);
    this.add(graphicContainer);

    // nineslice_2
    const nineslice_2 = scene.add.nineslice(
      0,
      0,
      'Hud3',
      undefined,
      42,
      20,
      10,
      10,
      10,
      10,
    );
    nineslice_2.scaleX = 4;
    nineslice_2.scaleY = 4;
    nineslice_2.setOrigin(1, 0);
    graphicContainer.add(nineslice_2);

    // notificationCosmeticIcon
    const notificationCosmeticIcon = scene.add.image(
      -136,
      36,
      'ui-black-long-dress-large',
    );
    graphicContainer.add(notificationCosmeticIcon);

    // purchaseSuccessArrow
    const purchaseSuccessArrow = scene.add.image(
      -84,
      36,
      'GuidanceArrow-Small',
    );
    purchaseSuccessArrow.scaleX = 3;
    purchaseSuccessArrow.scaleY = 3;
    purchaseSuccessArrow.angle = -90;
    purchaseSuccessArrow.flipY = true;
    graphicContainer.add(purchaseSuccessArrow);

    // purchaseSuccessBackpack
    const purchaseSuccessBackpack = scene.add.image(-32, 36, 'bag3');
    purchaseSuccessBackpack.scaleX = 3;
    purchaseSuccessBackpack.scaleY = 3;
    graphicContainer.add(purchaseSuccessBackpack);

    this.notificationCosmeticIcon = notificationCosmeticIcon;
    this.graphicContainer = graphicContainer;

    /* START-USER-CTR-CODE */
    this.graphicContainer.setX(168);
    /* END-USER-CTR-CODE */
  }

  public notificationCosmeticIcon: Phaser.GameObjects.Image;
  private graphicContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  async showPurchaseNotification(cosmetic: Customization) {
    this.graphicContainer.setX(168);
    this.scene.tweens.killTweensOf(this.graphicContainer);
    this.notificationCosmeticIcon.setTexture(getIconPath(cosmetic));
    this.setVisible(true);
    console.log('show notification', this);

    await waitForSeconds(this.scene.time, 0.2);

    PhaserAudioManager.playSFX(this.scene, 'item-purchased');
    console.log(this.graphicContainer.x);

    this.scene.tweens.add({
      targets: this.graphicContainer,
      x: 0,
      duration: 500,
      ease: 'Back.easeInOut',
    });

    // Out tween
    this.scene.tweens.add({
      targets: this.graphicContainer,
      x: 168,
      duration: 500,
      ease: 'Back.easeInOut',
      delay: 3000,
      onComplete: () => {},
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
